// extracted by mini-css-extract-plugin
export default {"version-block":"CurrentVersion_style__version-block___c0","version-info":"CurrentVersion_style__version-info___f8","version-date":"CurrentVersion_style__version-date___d0"};